export async function getMaturityFilterOptions(reportServices, endpoint, params = {}) {
  const response = await reportServices.getProjectReportDataMaturityModel(endpoint, { params });
  const filter = response?.data?.status ? response?.data?.data?.filter || {} : {};

  return {
    customers: Array.isArray(filter.customer) ? filter.customer : [],
    projects: Array.isArray(filter.project) ? filter.project : [],
  };
}
